function initWagyuAndFaqSliders(container = document) {
  // Wagyu Chart Sliders
  container.querySelectorAll(".wagyu-chart").forEach(function (chartEl) {
    const sectionId = chartEl.id.replace("wagyu-chart-", "");
    const chartSwiperEl = chartEl.querySelector(".wagyu-swiper-" + sectionId);

    if (chartSwiperEl) {
      // Destroy existing swiper instance if already initialized
      if (chartSwiperEl.swiper) {
        chartSwiperEl.swiper.destroy(true, true);
      }
      console.log("TEST", parseFloat(chartEl.dataset.slidesMobile));

      new Swiper(chartSwiperEl, {
        spaceBetween: 0,
        // pagination: {
        //   el: chartSwiperEl.querySelector(".swiper-pagination"),
        //   type: "progressbar",
        // },
        scrollbar: {
          el: '.swiper-scrollbar', // You'll need to add a new element for this
          draggable: true, // This is the key setting that allows dragging
        },
        breakpoints: {
          320: {
            slidesPerView: parseFloat(chartEl.dataset.slidesMobile) || 0.5,
          },
          992: {
            slidesPerView: parseFloat(chartEl.dataset.slidesDesktop) || 4,
          },
        },
      });
    }
  });
  

  // FAQ Sliders
  container.querySelectorAll(".faq-slider").forEach(function (faqEl) {
    const sectionId = faqEl.id.replace("faq-slider-", "");
    const faqSwiperEl = faqEl.querySelector(".faq-swiper-" + sectionId);

    if (faqSwiperEl) {
      // Destroy existing swiper instance if already initialized
      if (faqSwiperEl.swiper) {
        faqSwiperEl.swiper.destroy(true, true);
      }

      new Swiper(faqSwiperEl, {
        slidesPerView: 1,
        // autoHeight: true,
        loop: true,
        autoplay: {
          delay: parseInt(faqEl.dataset.autoscrollDelay) || 3000,
          disableOnInteraction: false,
        },
        pagination: {
          el: faqSwiperEl.querySelector(".swiper-pagination"),
          clickable: true,
        },
        navigation: {
          nextEl: faqSwiperEl.querySelector(".swiper-button-next"),
          prevEl: faqSwiperEl.querySelector(".swiper-button-prev"),
        },
      });
    }
  });
}

// Run on first page load
document.addEventListener("DOMContentLoaded", function () {
  initWagyuAndFaqSliders();
});

// Re-run whenever Shopify refreshes section in the editor
document.addEventListener("shopify:section:load", function (event) {
  initWagyuAndFaqSliders(event.target);
});
